
(function(){
function ocmFaqInit(){
  var wrap=document.querySelector('.ocm-faq-wrap');
  var tabs=document.getElementById('ocm-faq-tabs');
  if(!wrap || !tabs) return false;
  if(wrap.getAttribute('data-bound')) return true;
  wrap.setAttribute('data-bound','1');
 
  var STORAGE_RECENT='ocm-faq-recent-v1';
  var STORAGE_STICKY='ocm-faq-sticky-dismissed';
  var SESSION_OPEN='ocm-faq-open-v1';
  var MAX_RECENT=5;
 
  var allTabs=tabs.querySelectorAll('.ocm-faq-tab');
  var allCats=wrap.querySelectorAll('.ocm-faq-category');
  var allItems=wrap.querySelectorAll('.ocm-faq-item');
  var searchInput=document.getElementById('ocm-faq-search');
  var searchClear=document.getElementById('ocm-faq-search-clear');
  var searchCount=document.getElementById('ocm-faq-search-count');
  var recentBox=document.getElementById('ocm-faq-recent');
  var noResults=document.getElementById('ocm-faq-no-results');
  var suggestBox=document.getElementById('ocm-faq-suggest');
  var stickyEl=document.getElementById('ocm-faq-sticky');
  var stickyClose=document.getElementById('ocm-faq-sticky-close');
  var activeCat='all';
 
  /* Cache originals so we can restore between searches */
  for(var i=0;i<allItems.length;i++){
    var qEl=allItems[i].querySelector('.ocm-faq-q');
    var aEl=allItems[i].querySelector('.ocm-faq-a');
    if(qEl) qEl._ocmOriginal=qEl.innerHTML;
    if(aEl) aEl._ocmOriginal=aEl.innerHTML;
  }
 
  /* ---- Computed tab counts ---- */
  function updateTabCounts(){
    var allCountEl=document.querySelector('[data-count-for="all"]');
    if(allCountEl) allCountEl.textContent=allItems.length;
    for(var c=0;c<allCats.length;c++){
      var cat=allCats[c];
      var name=cat.getAttribute('data-cat');
      var count=cat.querySelectorAll('.ocm-faq-item').length;
      var el=document.querySelector('[data-count-for="'+name+'"]');
      if(el) el.textContent=count;
    }
  }
  updateTabCounts();
 
  /* ---- Storage helpers ---- */
  function safeGet(key,fallback){
    try{var v=localStorage.getItem(key);return v?JSON.parse(v):fallback;}catch(e){return fallback;}
  }
  function safeSet(key,val){
    try{localStorage.setItem(key,JSON.stringify(val));}catch(e){}
  }
  function sessGet(key,fallback){
    try{var v=sessionStorage.getItem(key);return v?JSON.parse(v):fallback;}catch(e){return fallback;}
  }
  function sessSet(key,val){
    try{sessionStorage.setItem(key,JSON.stringify(val));}catch(e){}
  }
 
  /* ---- Highlight helpers ---- */
  function escapeRegex(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
  function highlightInElement(el,query){
    if(!query||!el) return;
    var pattern=escapeRegex(query);
    var walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null,false);
    var nodes=[];
    var n;
    while((n=walker.nextNode())) nodes.push(n);
    for(var j=0;j<nodes.length;j++){
      var node=nodes[j];
      if(node.parentNode && (node.parentNode.tagName==='BUTTON' || node.parentNode.tagName==='SCRIPT' || node.parentNode.tagName==='STYLE')) continue;
      var text=node.nodeValue;
      var rx=new RegExp(pattern,'gi');
      if(!rx.test(text)) continue;
      rx.lastIndex=0;
      var frag=document.createDocumentFragment();
      var lastIdx=0;
      var match;
      while((match=rx.exec(text))!==null){
        if(match.index>lastIdx) frag.appendChild(document.createTextNode(text.substring(lastIdx,match.index)));
        var mark=document.createElement('mark');
        mark.className='ocm-faq-highlight';
        mark.textContent=match[0];
        frag.appendChild(mark);
        lastIdx=match.index+match[0].length;
        if(match.index===rx.lastIndex) rx.lastIndex++;
      }
      if(lastIdx<text.length) frag.appendChild(document.createTextNode(text.substring(lastIdx)));
      node.parentNode.replaceChild(frag,node);
    }
  }
 
  /* ---- Open / close helpers (sync ARIA + session storage) ---- */
  function setOpen(item,open){
    var q=item.querySelector('.ocm-faq-q');
    if(open){
      item.classList.add('ocm-faq-open');
      if(q) q.setAttribute('aria-expanded','true');
    } else {
      item.classList.remove('ocm-faq-open');
      if(q) q.setAttribute('aria-expanded','false');
    }
  }
  function persistOpenState(){
    var ids=[];
    for(var i=0;i<allItems.length;i++){
      if(allItems[i].classList.contains('ocm-faq-open')) ids.push(allItems[i].id);
    }
    sessSet(SESSION_OPEN,ids);
  }
  function restoreOpenState(){
    var ids=sessGet(SESSION_OPEN,[]);
    if(!ids || !ids.length) return;
    for(var i=0;i<ids.length;i++){
      var el=document.getElementById(ids[i]);
      if(el && el.classList.contains('ocm-faq-item')) setOpen(el,true);
    }
  }
 
  /* ---- Recent searches ---- */
  function renderRecent(){
    if(!recentBox) return;
    var list=safeGet(STORAGE_RECENT,[]);
    if(!list || !list.length){recentBox.hidden=true;recentBox.innerHTML='';return;}
    recentBox.hidden=false;
    var html='<span class="ocm-faq-recent-label">Recent:</span>';
    for(var i=0;i<list.length;i++){
      var term=list[i];
      var safe=term.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
      html+='<span class="ocm-faq-recent-chip" data-term="'+safe+'">'+safe+'<span class="ocm-faq-recent-chip-x" data-remove="'+safe+'">✕</span></span>';
    }
    recentBox.innerHTML=html;
  }
  function pushRecent(term){
    if(!term||term.length<2) return;
    var list=safeGet(STORAGE_RECENT,[]);
    list=list.filter(function(t){return t!==term;});
    list.unshift(term);
    if(list.length>MAX_RECENT) list=list.slice(0,MAX_RECENT);
    safeSet(STORAGE_RECENT,list);
  }
  function removeRecent(term){
    var list=safeGet(STORAGE_RECENT,[]);
    list=list.filter(function(t){return t!==term;});
    safeSet(STORAGE_RECENT,list);
    renderRecent();
  }
  renderRecent();
 
  if(recentBox){
    recentBox.addEventListener('click',function(e){
      var rm=e.target.getAttribute('data-remove');
      if(rm){e.stopPropagation();removeRecent(rm);return;}
      var chip=e.target.closest && e.target.closest('.ocm-faq-recent-chip');
      if(chip){
        var term=chip.getAttribute('data-term');
        if(term && searchInput){
          searchInput.value=term;
          filterDisplay();
        }
      }
    });
  }
 
  /* ---- Suggestion engine (n-gram overlap) for "Did you mean" ---- */
  function bigrams(str){
    str=' '+str.toLowerCase()+' ';
    var out=[];
    for(var i=0;i<str.length-1;i++) out.push(str.substring(i,i+2));
    return out;
  }
  function diceCoef(a,b){
    if(!a.length||!b.length) return 0;
    var counts={};
    for(var i=0;i<a.length;i++) counts[a[i]]=(counts[a[i]]||0)+1;
    var match=0;
    for(var j=0;j<b.length;j++) if(counts[b[j]]>0){match++;counts[b[j]]--;}
    return (2*match)/(a.length+b.length);
  }
  function buildSuggestions(query){
    if(!suggestBox) return;
    var qbg=bigrams(query);
    var scored=[];
    for(var i=0;i<allItems.length;i++){
      var qEl=allItems[i].querySelector('.ocm-faq-q');
      if(!qEl) continue;
      var text=qEl.textContent.replace(/🔗/g,'').trim();
      var score=diceCoef(qbg,bigrams(text));
      scored.push({el:allItems[i],text:text,score:score,id:allItems[i].id});
    }
    scored.sort(function(a,b){return b.score-a.score;});
    var top=scored.slice(0,3).filter(function(s){return s.score>0.15;});
    if(!top.length){suggestBox.innerHTML='';return;}
    var html='<span class="ocm-faq-suggest-label">Did you mean:</span>';
    for(var k=0;k<top.length;k++){
      var safe=top[k].text.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
      html+='<a href="#'+top[k].id+'" class="ocm-faq-suggest-link" data-suggest-id="'+top[k].id+'">'+safe+'</a>';
    }
    suggestBox.innerHTML=html;
  }
  if(suggestBox){
    suggestBox.addEventListener('click',function(e){
      var id=e.target.getAttribute('data-suggest-id');
      if(id){
        e.preventDefault();
        if(searchInput) searchInput.value='';
        filterDisplay();
        openAndScrollTo(id);
      }
    });
  }
 
  /* ---- Tab click + keyboard ---- */
  function activateTab(tab){
    activeCat=tab.getAttribute('data-cat');
    for(var i=0;i<allTabs.length;i++){
      allTabs[i].classList.remove('ocm-faq-tab-active');
      allTabs[i].setAttribute('aria-selected','false');
    }
    tab.classList.add('ocm-faq-tab-active');
    tab.setAttribute('aria-selected','true');
    filterDisplay();
  }
  for(var t=0;t<allTabs.length;t++){
    (function(tab){
      tab.addEventListener('click',function(e){e.preventDefault();activateTab(this);});
      tab.addEventListener('keydown',function(e){
        if(e.key==='Enter'||e.key===' '){e.preventDefault();activateTab(this);}
      });
    })(allTabs[t]);
  }
 
  /* ---- Search ---- */
  var searchTimer=null;
  if(searchInput){
    searchInput.addEventListener('input',function(){
      if(searchClear) searchClear.classList.toggle('ocm-faq-show',!!this.value);
      filterDisplay();
      clearTimeout(searchTimer);
      var val=this.value.trim();
      if(val.length>=3){
        searchTimer=setTimeout(function(){pushRecent(val);renderRecent();},1200);
      }
    });
    searchInput.addEventListener('keydown',function(e){
      if(e.key==='Escape'){this.value='';if(searchClear) searchClear.classList.remove('ocm-faq-show');filterDisplay();this.blur();}
    });
  }
  if(searchClear){
    searchClear.addEventListener('click',function(){
      if(searchInput){searchInput.value='';searchInput.focus();}
      this.classList.remove('ocm-faq-show');
      filterDisplay();
    });
  }
  /* Global keyboard shortcut: "/" focuses search */
  document.addEventListener('keydown',function(e){
    if(e.key==='/' && document.activeElement!==searchInput){
      var tag=(document.activeElement && document.activeElement.tagName) || '';
      if(tag==='INPUT' || tag==='TEXTAREA') return;
      e.preventDefault();
      if(searchInput) searchInput.focus();
    }
  });
 
  function filterDisplay(){
    var query=(searchInput?searchInput.value:'').toLowerCase().trim();
    var visible=0;
 
    /* Restore all originals (clears prior highlights). Empty-query also collapses search-opened items. */
    for(var k=0;k<allItems.length;k++){
      var qe=allItems[k].querySelector('.ocm-faq-q');
      var ae=allItems[k].querySelector('.ocm-faq-a');
      if(qe && qe._ocmOriginal!==undefined) qe.innerHTML=qe._ocmOriginal;
      if(ae && ae._ocmOriginal!==undefined) ae.innerHTML=ae._ocmOriginal;
    }
 
    for(var c=0;c<allCats.length;c++){
      var cat=allCats[c];
      var catName=cat.getAttribute('data-cat');
      var catMatch=(activeCat==='all'||catName===activeCat);
      if(!catMatch){cat.classList.add('ocm-faq-hidden');continue;}
      cat.classList.remove('ocm-faq-hidden');
 
      var items=cat.querySelectorAll('.ocm-faq-item');
      var catVisible=0;
      for(var i=0;i<items.length;i++){
        var item=items[i];
        var qEl=item.querySelector('.ocm-faq-q');
        var aEl=item.querySelector('.ocm-faq-a');
        var text=((qEl?qEl.textContent:'')+(aEl?aEl.textContent:'')).toLowerCase();
        if(!query||text.indexOf(query)!==-1){
          item.classList.remove('ocm-faq-search-hide');
          catVisible++;visible++;
          if(query){
            highlightInElement(qEl,query);
            highlightInElement(aEl,query);
            setOpen(item,true);
          }
        } else {
          item.classList.add('ocm-faq-search-hide');
        }
      }
      if(catVisible===0 && query) cat.classList.add('ocm-faq-hidden');
    }
 
    if(noResults){
      if(visible===0 && query){
        noResults.classList.add('ocm-faq-show');
        buildSuggestions(query);
      } else {
        noResults.classList.remove('ocm-faq-show');
      }
    }
    if(searchCount){
      if(query) searchCount.textContent=visible+' question'+(visible!==1?'s':'')+' found';
      else searchCount.textContent='';
    }
  }
 
  /* ---- Accordion: event delegation + keyboard + ARIA ---- */
  wrap.addEventListener('click',function(e){
    /* Copy-link button */
    var copyBtn=e.target.closest && e.target.closest('.ocm-faq-copy');
    if(copyBtn){
      e.stopPropagation();
      var id=copyBtn.getAttribute('data-copy');
      var url=location.origin+location.pathname+'#'+id;
      var doCopy=function(text){
        if(navigator.clipboard && navigator.clipboard.writeText){
          return navigator.clipboard.writeText(text);
        }
        var ta=document.createElement('textarea');
        ta.value=text;ta.style.position='fixed';ta.style.opacity='0';
        document.body.appendChild(ta);ta.select();
        try{document.execCommand('copy');}catch(err){}
        document.body.removeChild(ta);
        return Promise.resolve();
      };
      doCopy(url).then(function(){
        copyBtn.classList.add('ocm-faq-copied');
        setTimeout(function(){copyBtn.classList.remove('ocm-faq-copied');},1600);
      });
      return;
    }
    /* Question header toggles */
    var qHeader=e.target.closest && e.target.closest('.ocm-faq-q');
    if(qHeader){
      var item=qHeader.closest('.ocm-faq-item');
      if(item){
        var isOpen=item.classList.contains('ocm-faq-open');
        setOpen(item,!isOpen);
        persistOpenState();
      }
    }
  });
  wrap.addEventListener('keydown',function(e){
    var q=e.target.closest && e.target.closest('.ocm-faq-q');
    if(q && (e.key==='Enter'||e.key===' ')){
      if(e.target.classList && e.target.classList.contains('ocm-faq-copy')) return;
      e.preventDefault();
      var item=q.closest('.ocm-faq-item');
      if(item){
        var isOpen=item.classList.contains('ocm-faq-open');
        setOpen(item,!isOpen);
        persistOpenState();
      }
    }
  });
 
  /* ---- Expand / collapse all ---- */
  var toggleAllBtns=wrap.querySelectorAll('.ocm-faq-toggle-all');
  for(var b=0;b<toggleAllBtns.length;b++){
    (function(btn){
      btn.addEventListener('click',function(){
        var action=this.getAttribute('data-action');
        for(var i=0;i<allItems.length;i++){
          if(allItems[i].classList.contains('ocm-faq-search-hide')) continue;
          if(allItems[i].closest('.ocm-faq-hidden')) continue;
          setOpen(allItems[i],action==='expand');
        }
        persistOpenState();
      });
    })(toggleAllBtns[b]);
  }
 
  /* ---- Hash routing (deep links / shareable URLs) ---- */
  function openAndScrollTo(id){
    var el=document.getElementById(id);
    if(!el || !el.classList.contains('ocm-faq-item')) return;
    /* Switch to the right category tab */
    var cat=el.closest('.ocm-faq-category');
    if(cat){
      var catSlug=cat.getAttribute('data-cat');
      for(var i=0;i<allTabs.length;i++){
        if(allTabs[i].getAttribute('data-cat')===catSlug){activateTab(allTabs[i]);break;}
      }
    }
    setOpen(el,true);
    persistOpenState();
    el.classList.add('ocm-faq-target');
    setTimeout(function(){el.classList.remove('ocm-faq-target');},2400);
    setTimeout(function(){el.scrollIntoView({behavior:'smooth',block:'start'});},80);
  }
  if(location.hash && location.hash.length>1){
    openAndScrollTo(location.hash.substring(1));
  }
  window.addEventListener('hashchange',function(){
    if(location.hash.length>1) openAndScrollTo(location.hash.substring(1));
  });
 
  restoreOpenState();
 
  /* ---- Sticky mobile CTA ---- */
  if(stickyEl){
    var dismissed=safeGet(STORAGE_STICKY,false);
    if(!dismissed){
      var shown=false;
      var maybeShow=function(){
        if(shown) return;
        if(window.scrollY>400){
          stickyEl.classList.add('ocm-faq-show');
          shown=true;
        }
      };
      window.addEventListener('scroll',maybeShow,{passive:true});
      maybeShow();
    }
    if(stickyClose){
      stickyClose.addEventListener('click',function(){
        stickyEl.classList.remove('ocm-faq-show');
        safeSet(STORAGE_STICKY,true);
      });
    }
  }
 
  return true;
}
 
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',ocmFaqInit);
else ocmFaqInit();
if(!ocmFaqInit()){var r=setInterval(function(){if(ocmFaqInit())clearInterval(r);},300);setTimeout(function(){clearInterval(r);},8000);}
})();